// removed by extract-text-webpack-plugin
module.exports = {"title":"src-pages----index-module---title---2oVtp","panelWrap":"src-pages----index-module---panelWrap---1dD5_","allPanelWrap":"src-pages----index-module---allPanelWrap---3oPSA","panel":"src-pages----index-module---panel---3wBmv","featuredPanel":"src-pages----index-module---featuredPanel---3Rnua src-pages----index-module---panel---3wBmv","pageLink":"src-pages----index-module---pageLink---1yTTb"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.css
// module id = 298
// module chunks = 35783957827783